import store from '../../store'

export function showNewTemplateInModal(templateId) {	
	console.log('open modal')
	console.log(templateId)
	store.dispatch({type:'SHOW_NEW_TEMPLATE_MODAL',newTemplateId:templateId})
}
